import proj1 from "../Assets/img1.png";
import proj2 from "../Assets/img2.png";
import proj3 from "../Assets/img3.png";
import ProjectsItem from "../Components/ProjectsItem";
import "../Components/ProjectStyle.css";
const ProjectList = () => {
    return (
        <div className="proj-container">
            <div className="project">
                <h1 className="title">My Projects</h1>
                <div className="projectList">
                    <ProjectsItem image={proj1} name="Tour and Travel Website" detail="I have built this project using React js and This is my Tour and Travel website project where user can get the complete details of the tour and travel, packages." url="https://reacttravelapp.netlify.app/" />
                    <ProjectsItem image={proj2} name="E-Commerce Website" detail="This is my first project using JavaScript, CSS, HTML. This is fully respopnsive e-Commerce website where user is just a click away to purchase anything online." url="https://rishav812.github.io/ShopGood/" />
                    <ProjectsItem image={proj3} name="Weather App" detail="This was my first React js Projects which is full responsive Weather App through which anyone from anywhere can access the weather details about any desired place. I have used API in this project." url="https://rishav812.github.io/weatherApp/" />
                </div>
            </div>
        </div>
    )
}
export default ProjectList;